import TopBar from "./components/TopBar";
import Hero from "./components/Hero";
import QuickEntries from "./components/QuickEntries";
import TimelineSection from "./components/TimelineSection";
import EventGrid from "./components/EventGrid";
import RankingSection from "./components/RankingSection";
import GallerySection from "./components/GallerySection";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <TopBar />
      <main>
        <Hero />
        <QuickEntries />
        <TimelineSection />
        <EventGrid />
        <RankingSection />
        <GallerySection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <SiteFooter />
    </div>
  );
}